import styled from "styled-components";

export const Wrapper = styled.div`
  background: #f8f8f8;
  /* border: 1px solid blue; */
  height: 100%;
`;